module.exports = __webpack_public_path__ + "img/bg11.58864dcd.jpg";